import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=2d348a54&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=2d348a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d348a54",
  null
  
)

export default component.exports